export default function Properties() {
  return <div>Properties Page</div>;
}

